import React from "react";
import { Link } from "react-router-dom";

const testimonials = [
  {
    id: 1,
    name: "Michael Anderson",
    role: "Marketing Manager",
    feedback:
      "Excellent service and fast delivery every time. The print quality exceeded expectations, and the website made ordering incredibly simple and convenient.",
    rating: 5,
  },
  {
    id: 2,
    name: "Sarah Thompson",
    role: "Graphic Designer",
    feedback:
      "I’ve ordered multiple cartridges, and they always arrive on time. Genuine quality, great support, and smooth checkout every single purchase experience.",
    rating: 5,
  },
  {
    id: 3,
    name: "James Carter",
    role: "IT Specialist",
    feedback:
      "The best online store for office printing needs. Secure payment options, real-time tracking, and professional support make it absolutely reliable always.",
    rating: 4,
  },
  {
    id: 4,
    name: "Emily Johnson",
    role: "Freelance Photographer",
    feedback:
      "Beautiful printing results on every project. I trust their genuine products completely, and customer support always responds quickly and efficiently too.",
    rating: 5,
  },
  {
    id: 5,
    name: "Robert Williams",
    role: "Operations Director",
    feedback:
      "Highly recommend this store. Prices are fair, products are authentic, and delivery is quick — very dependable for all my office requirements.",
    rating: 4,
  },
  {
    id: 6,
    name: "Jessica Miller",
    role: "Content Creator",
    feedback:
      "Super easy to use website, fast service, and genuine cartridges. Every order has been perfect, reliable, and worth every penny invested here.",
    rating: 5,
  },
];

const PromotionalTwo = () => {
  return (
    <section
      className="offer sec-grey"
      style={{
        background: "#f8f9fa",
        padding: "80px 0",
      }}
    >
      <div className="container container-lg">
        <h3 className="text-center mb-3" style={{ fontWeight: "700" }}>
          What Our Customers Say
        </h3>
        <p
          className="text-center mb-5"
          style={{
            fontSize: "16px",
            maxWidth: "700px",
            margin: "0 auto",
            color: "#555",
          }}
        >
          Hear from our satisfied customers who trust Printing Dealz for
          authentic products, fast delivery, and friendly support. Their
          experiences speak for the quality and reliability we deliver.
        </p>

        <div className="row gy-4">
          {testimonials.map((item) => (
            <div className="col-xxl-4 col-sm-6" key={item.id}>
              <div
                className="testimonial-item rounded-4 p-4 h-100"
                style={{
                  border: "1px solid #e5e7eb",
                  backgroundColor: "#fff",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                  transition: "all 0.3s ease",
                  height: "100%",
                }}
              >
                <p
                  className="text-muted mb-3"
                  style={{
                    fontSize: "15px",
                    lineHeight: "1.7",
                    color: "#444",
                  }}
                >
                  “{item.feedback}”
                </p>

                <div className="d-flex align-items-center justify-content-between mt-4">
                  <div>
                    <h6
                      className="mb-0 fw-bold"
                      style={{ color: "#e63946", fontSize: "16px" }}
                    >
                      {item.name}
                    </h6>
                    <span
                      className="text-secondary"
                      style={{ fontSize: "14px" }}
                    >
                      {item.role}
                    </span>
                  </div>
                  <div className="text-warning" style={{ fontSize: "18px" }}>
                    {"★".repeat(item.rating)}
                    <span style={{ color: "#ccc" }}>
                      {"★".repeat(5 - item.rating)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5">
          <Link
            to="/shop"
            className="btn btn-outline-danger rounded-pill px-4 py-2 fw-semibold"
            style={{ borderWidth: "2px", transition: "0.3s" }}
          >
            Shop Now{" "}
            <i
              className="ph ph-shopping-cart-simple ms-2"
              style={{ fontSize: "18px" }}
            ></i>
          </Link>
        </div>
      </div>

      <style>
        {`
          .testimonial-item:hover {
            transform: translateY(-6px);
            box-shadow: 0 8px 20px rgba(0,0,0,0.1);
          }
          .btn-outline-danger:hover {
            background-color: #e63946;
            color: #fff !important;
          }
        `}
      </style>
    </section>
  );
};

export default PromotionalTwo;
